export const CardIcon: { [id: string]: string } = {
  'Educational Qualifications': '/Education.png',
  Experiences: '/Experiences.png',
  'Soft Skills': '/Soft-Skills.png',
  'Core Skills': '/Core-Skills.png',
  Plans: '/Plans.png',
  Achievement: '/achievements.png',
  Project: '/projects.png',
  Strength: '/strength.png',
};
